import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUsers = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		d: "M3.375 7.875C3.375 8.96902 3.8096 10.0182 4.58318 10.7918C5.35677 11.5654 6.40598 12 7.5 12C8.59402 12 9.64323 11.5654 10.4168 10.7918C11.1904 10.0182 11.625 8.96902 11.625 7.875C11.625 6.78098 11.1904 5.73177 10.4168 4.95818C9.64323 4.1846 8.59402 3.75 7.5 3.75C6.40598 3.75 5.35677 4.1846 4.58318 4.95818C3.8096 5.73177 3.375 6.78098 3.375 7.875Z",
		fill: "none",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M0.75 20.25C0.75 18.4598 1.46116 16.7429 2.72703 15.477C3.9929 14.2112 5.70979 13.5 7.5 13.5C9.29021 13.5 11.0071 14.2112 12.273 15.477C13.5388 16.7429 14.25 18.4598 14.25 20.25",
		stroke: "currentcolor",
		fill: "none",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.352 10.125C14.352 11.0201 14.7076 11.8785 15.3405 12.5115C15.9734 13.1444 16.8319 13.5 17.727 13.5C18.6221 13.5 19.4805 13.1444 20.1135 12.5115C20.7464 11.8785 21.102 11.0201 21.102 10.125C21.102 9.22989 20.7464 8.37145 20.1135 7.73851C19.4805 7.10558 18.6221 6.75 17.727 6.75C16.8319 6.75 15.9734 7.10558 15.3405 7.73851C14.7076 8.37145 14.352 9.22989 14.352 10.125Z",
		fill: "none",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15.813 15.068C16.6481 14.7602 17.5451 14.6587 18.4279 14.7721C19.3106 14.8854 20.1529 15.2103 20.8832 15.7191C21.6134 16.2279 22.2099 16.9056 22.622 17.6944C23.034 18.4833 23.2495 19.36 23.25 20.25",
		fill: "none",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}));
});
export default SvgUsers;
